import type { FC } from "react";
import Icon from "../../../../components/general/Icon";
import type { MouseClickEventHandler } from "../../../../type-definitions/utility-types";
import * as s from "./PlayButton.module.scss";

type MouseClickProps = {
	onClick: MouseClickEventHandler;
	ariaLabel: string;
};

const PlayButton: FC<MouseClickProps> = ({ onClick, ariaLabel }) => (
	<button
		className={s.playButton}
		onClick={onClick}
		aria-label={ariaLabel}
		type="button"
	>
		<Icon icon="play" />
	</button>
);

export default PlayButton;
